import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

// VERSION ACCÈS LIBRE - Pas d'authentification requise
// Retourne toujours un utilisateur "anonyme" avec accès complet

export function AuthProvider({ children }) {
  // ACCÈS LIBRE: Pas d'authentification, pas de vérification
  // Utilisateur anonyme avec accès complet par défaut

  // Utilisateur anonyme par défaut (accès libre)
  const anonymousUser = {
    name: "Utilisateur",
    email: "anonymous@urgencemed.com",
    role: "Médecin",
    _id: "anonymous",
    favorites: []
  };

  const login = async () => {
    // Accès libre: login ne fait rien
    return { success: true };
  };

  const register = async () => {
    // Accès libre: register ne fait rien
    return { success: true };
  };

  const logout = () => {
    // Accès libre: logout ne fait rien
  };

  const value = {
    user: anonymousUser, // Toujours un utilisateur anonyme
    token: null,
    loading: false, // Pas de loading, accès immédiat
    login,
    register,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
